import type { ReactNode } from 'react';
import type { PtoRdImportStatus } from '@shared/api';
import { Tone } from './styles';

const LABELS: Record<PtoRdImportStatus, string> = {
  uploading: 'загрузка файлов',
  queued: 'в очереди на распознавание',
  recognizing: 'распознавание',
  review: 'на проверке',
  applying: 'загрузка в реестр',
  applied: 'загружен',
  failed: 'ошибка',
};

export function statusLabel(s: PtoRdImportStatus): string {
  return LABELS[s] ?? s;
}

/** Пакет в работе на сервере: ждёт распознавания, распознаётся или загружается в реестр. */
export function isWorking(s: PtoRdImportStatus): boolean {
  return s === 'queued' || s === 'recognizing' || s === 'applying';
}

export function StatusTone({
  status,
  children,
}: {
  status: PtoRdImportStatus;
  children: ReactNode;
}) {
  const tone =
    status === 'applied'
      ? 'ok'
      : status === 'failed'
        ? 'bad'
        : status === 'review'
          ? 'warn'
          : status === 'uploading'
            ? 'muted'
            : 'accent';
  return <Tone $tone={tone}>{children}</Tone>;
}
